module.exports = "<div style=\"text-align:center\">\n  <div #lanaContainer id=\"lanaContainer\"></div>\n</div>\n\n"